import { Box, Button, Stack, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Phone as PhoneIcon } from '@mui/icons-material';

import { Search, SearchType } from '@carcareers/components';
import { routes } from '@carcareers/utils';
import { useAuth } from '@carcareers/hooks';

export const AppbarNoAuth = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const showButtons = location.pathname?.substring(1) !== routes?.JOBSEEKERS;

  if (session?.user !== undefined && showButtons) {
    return <Box sx={{ flexGrow: 1 }} />;
  }

  return (
    <>
      {location.pathname?.substring(1) === routes?.JOBSEEKERS && <Search searchType={SearchType.NO_AUTH_JOBSEEKER} />}
      <Box
        sx={{
          justifyContent: 'right',
          flexGrow: 1,
          display: showButtons ? { xs: 'none', md: 'flex' } : 'none',
          mr: 3,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ marginRight: 2 }}>
          <PhoneIcon sx={{ fontSize: 16, color: 'primary.main' }} />
          <Link
            href="tel:8883979797"
            sx={{
              color: 'text.primary',
              textDecoration: 'none',
              fontSize: '0.875rem',
              '&:hover': { color: 'primary.main' },
            }}
          >
            (888) 397-9797
          </Link>
        </Stack>
        <Button onClick={() => navigate(`/${routes.JOBSEEKERS}`)} sx={{ color: 'text.primary', fontWeight: 700 }}>
          Job Seekers
        </Button>
        <Button onClick={() => navigate(`/${routes.EMPLOYERS}`)} sx={{ color: 'text.primary', fontWeight: 700 }}>
          Employers
        </Button>
      </Box>
    </>
  );
};

export default AppbarNoAuth;
